import { render, staticRenderFns } from "./ChargingPointAdd.vue?vue&type=template&id=56e610a1"
import script from "./ChargingPointAdd.vue?vue&type=script&lang=js"
export * from "./ChargingPointAdd.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointAdd.vue?vue&type=style&index=0&id=56e610a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports